import { render } from "./UpdateNotification.vue?vue&type=template&id=0e9747c7"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2158973318/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__